import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import * as Highcharts from 'highcharts';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
/*import { OrderByPipe } from '@angular/common';*/

import * as _ from 'lodash';
import { TableViewService } from '../../table-view.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { Subscription } from 'rxjs';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';


@Component({
  selector: 'app-table1-component',
  templateUrl: './table1-component.component.html',
  styleUrls: ['./table1-component.component.scss']
  /*changeDetection: ChangeDetectionStrategy.OnPush*/
  // providers: [OrderByPipe],
})
export class Table1ComponentComponent implements OnInit {
  jsonData: any;
  data: any;
  tableData: any;
  headers: any;
  valuesArray: any = {
    data1: [],
    data2: [],
    data3: [],
    data4: [],
    data5: [],
    data6: [],
    data7: [],
    data8: [],
    data9: [],
    data10: []

  };
  usaValues: any;
  properties: any;
  tableTitle: any;
  categories: any[] = [];
  p: number = 1; // Current page
  itemsPerPage: any; // Number of items per page
  valuesArray2: any;
  headers1: any[] = [];
  sortcolumn: string | null = null;
  headers2: any;
  start: any;
  end: any;
  significanceValue: any = "None";
  chartMainData: any = [];
  rowLayout: any = false;
  tableContent: any;
  clickCounts: { [key: string]: number } = {};
  categories2: any;
  dataCellCache: { [key: string]: any } = {}
  trans: any;
  userselectedchartdata: any;
  sorting: any = 'nosort';
  sortDirectionAsc: any = true;
  sortDirectionDesc: any = true;
  header2: any = [];
  Output:any=false;
  DefaultConfidenceLevel: any = "";
  SigValue="None";
  ConfidenceLevel:any="";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  selectedColumn:any='';
  selectedascending:any='';
  CurrentWidgetName:any="";
  bipsDefaultColor:any='#CAC4C4';

  @Input() popUp: any=false;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any="24em";
  @Input() isOutput: any=false;
  constructor(private http: HttpClient, public tableService: TableViewService, private sanitizer: DomSanitizer,private router: Router,
    private route: ActivatedRoute,private _customSnapshotService: CustomsnapshotService,private _configService: SnapshotService) { }
  @ViewChild('customTable') customTable: ElementRef | undefined;
  @ViewChild('headerElement') headerElement: ElementRef | undefined;
  @ViewChildren('dataCell') dataCells: QueryList<ElementRef> | any;
  private subscriptions: Subscription = new Subscription();
  ngOnInit() {

    if(this.isOutput){
      let Properties=JSON.parse(this.customData.customizationProperties);
      let Properties1;
      for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
        if(this.customData.widget_name == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
          Properties1=JSON.parse(this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties);
        }
      }
      if(Properties1.selectedColumn != undefined){
        Properties.selectedColumn = Properties1.selectedColumn;
      }
      if(Properties1.selectedsorting != undefined){
        Properties.selectedsorting = Properties1.selectedsorting;
      }
      this.properties=Properties;
      if(this.customData){
         for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
              if(this.customData.widget_name == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
                this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(Properties);
              }
         }
      }
      this.CurrentWidgetName=this.customData.widget_name ;
      this.customData = this.customData.metric[0];
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updatesig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updatesig();
        }));
      //this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      this.preparemainChartData(this.customData);
      this.getData(this.chartMainData, 0, this.itemsPerPage, "",'nosort');
    }
    else{
        this.http.get<any>('assets/Data/tableData.json').subscribe((data: any) => {
          this.jsonData = data;

          this.data = data[0];
          this.properties = data[0]["properties"][0];
          this.route.paramMap.subscribe((params) => {
            const userData = history.state.userData;
            this.userselectedchartdata = userData; // Use the userData object as needed
            if (this.userselectedchartdata?.widgetEditSelection) {
              if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
                this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
              }
            }
          });
          this.tableData = data;
          this.tableContent = data;
          this.header2 = [];
          this.header2.push('Metric2');
          this.header2.push('asc');
          this.getData(this.tableData[0].data, 0, this.itemsPerPage, "",'nosort');
          this.headers2 = this.headers.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
          // For headers
          this.headers2 = this.headers.map((category: any, index: number) => {
            return { colname: category, sortorder: index === 1 ? 'asc' : 'nosort' };
          });

          // For categories
          this.categories2 = this.categories.map((category, index) => {
            return { colname: category, sortorder: index === 0 ? 'asc' : 'nosort' };
          });

          const allCategoryNames: string[] = this.tableData[0].data.map((item: { [x: string]: string }) => item['Category Name']);

          // Use Set to get unique category names
          const uniqueCategoryNames: string[] = Array.from(new Set(allCategoryNames));

          // Calculate the length of unique category names
          const uniqueCategoryNamesLength: number = uniqueCategoryNames.length;
          this.itemsPerPage = 10;
          this.tableTitle = this.tableData[0].title;
          
          this.customization(); //function to customize the table
          localStorage.setItem("properties", JSON.stringify(this.properties));
        });
    }


    const tableLeftFixedDiv = document.querySelector('.table-bodys2') as HTMLElement;
    const tableFreezFixedDiv = document.querySelector('.columnHeader') as HTMLElement;
    const scrollDiv = document.querySelector('.content') as HTMLElement;

    let isScrolling = false;

    if (scrollDiv) {
      scrollDiv.addEventListener('scroll', () => {
        if (!isScrolling) {
          isScrolling = true;

          requestAnimationFrame(() => {
            const x = scrollDiv.scrollLeft;
            const y = scrollDiv.scrollTop;
            // tableLeftFixedDiv ? tableLeftFixedDiv.style.top = -y + 'px' : '';
            // tableFreezFixedDiv ? tableFreezFixedDiv.style.left = -x + 'px' : '';
            // if (tableLeftFixedDiv) {
            //   tableLeftFixedDiv.style.top = -y + "em";
            //   tableLeftFixedDiv.offsetHeight;
            // }
            // if (tableFreezFixedDiv){
            //    tableFreezFixedDiv.style.left = -x + "em";
            //    tableFreezFixedDiv.offsetHeight;
            //   }
            if (tableFreezFixedDiv){
              // tableFreezFixedDiv.style.willChange = "transform";
              // tableFreezFixedDiv.style.setProperty('transform', `translateX(${-x}px) translateY(0)`, 'important');
              // tableFreezFixedDiv.style.display = "none";
              tableFreezFixedDiv.style.left = -x + 'px';
            }
            if (tableLeftFixedDiv)
              {
                tableLeftFixedDiv.style.top = -y + 'px';
                //  tableLeftFixedDiv.style.transform = `translateY(${-y}px)`;
              }

            isScrolling = false;
          });
        }
      });
    }


  }

  ngOnchanges() {
    const tableLeftFixedDiv = document.querySelector('.table-bodys2') as HTMLElement;
    const tableFreezFixedDiv = document.querySelector('.header') as HTMLElement;
    const scrollDiv = document.querySelector('.content') as HTMLElement;

    let isScrolling = false;

    if (scrollDiv) {
      scrollDiv.addEventListener('scroll', () => {
        if (!isScrolling) {
          isScrolling = true;

          requestAnimationFrame(() => {
            const x = scrollDiv.scrollLeft;
            const y = scrollDiv.scrollTop;
            tableLeftFixedDiv ? tableLeftFixedDiv.style.top = -y + 'px' : '';
            tableFreezFixedDiv ? tableFreezFixedDiv.style.left = -x + 'px' : '';

            isScrolling = false;
          });
        }
      });
    }
    //this.getMarginForScroll();
  }


  updatesig(){
      this.SigValue=this.significanceValue;
      this.ConfidenceLevel=this.DefaultConfidenceLevel;
      this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_99
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_99
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
                this.preparemainChartData(this.customData);
                this.getData(this.chartMainData, 0, this.itemsPerPage, "",'nosort');
  }

  maxData:any=100;
  minData:any=-100;
  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;
        
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.option,
            "Rounded Value":dataArr.data!=null ?(dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ?(this.properties.CalculationLogic!="BIPS"?dataArr.data * 100: dataArr.data ): (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)):"NA",
            "Value": dataArr.data!=null ?(dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? (this.properties.CalculationLogic!="BIPS"?dataArr.data * 100: dataArr.data ) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)):"NA",
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && (dataArr.data2 == "NA" || dataArr.data2 == null || dataArr.data2 == undefined)? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? "NA" : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data!=null ?(dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? (this.properties.CalculationLogic!="BIPS"?dataArr.data * 100: dataArr.data ) : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)):"NA",
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? this.properties.CalculationLogic!="BIPS"?true:false : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild,
            "Category Name": lev2.option,
            "Rounded Value": dataArr.data!=null ?(dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)):"NA",
            "Value": dataArr.data!=null ?(dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)):"NA",
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA"&& dataArr.data2 == null && dataArr.data2 == undefined? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? "NA" : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data!=null ?(dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)):"NA",
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    }

    this.maxData=Math.max(
      ...this.chartMainData
        .map((item:any) => Number(item["Value"])) // Convert "Value" to a number
        .filter((value:any) => !isNaN(value)) // Filter out invalid values like "NA"
    );
    this.minData=Math.min(
      ...this.chartMainData
        .map((item:any) => Number(item["Value"])) // Convert "Value" to a number
        .filter((value:any) => !isNaN(value)) // Filter out invalid values like "NA"
    );

  }
  
  getBarWidth(value: any): string {
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    }  
    if(!isNaN(value.changingThisBreaksApplicationSecurity)){
      value=Number(value.changingThisBreaksApplicationSecurity);
    }
    else{
      value=0;
    }
    const maxValue = Math.abs(this.maxData)>Math.abs(this.minData)?Math.abs(this.maxData):Math.abs(this.minData); // Set max value for scaling (adjust as needed)
    let percentage = (Math.abs(value) / maxValue) * (this.properties.CalculationLogic=='None'?20:30); // Scale to 50%
    return `${percentage}%`;
  }

  getActualNumber(value: any){
    if(!isNaN(value.changingThisBreaksApplicationSecurity)){
      value=Number(value.changingThisBreaksApplicationSecurity);
    }
    else{
      value=0;
    }
    return value;
  }
  
  getBarClass(value: any): string {
    if(!isNaN(value.changingThisBreaksApplicationSecurity)){
      value=Number(value.changingThisBreaksApplicationSecurity);
    }
    else{
      value=0;
    }
    return value >= 0 ? 'positive' : 'negative';
  }
  getMarginLeft(value: any): string {
    if(!isNaN(value.changingThisBreaksApplicationSecurity)){
      value=Number(value.changingThisBreaksApplicationSecurity);
    }
    else{
      value=0;
    }
    return value < 0 ? '0' : 'auto'; // Push positive bars to the right
  }
  
  isValueLessThanZero(value:any){
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    } 
    if(!isNaN(value.changingThisBreaksApplicationSecurity)){
      value=Number(value.changingThisBreaksApplicationSecurity);
    }
    else{
      value=0;
    }
    
    return value<0;
  }

  isValueGreaterThanZero(value:any){
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    } 
    if(!isNaN(value.changingThisBreaksApplicationSecurity)){
      value=Number(value.changingThisBreaksApplicationSecurity);
    }
    else{
      value=0;
    }
    
    return value>0;
  }
  
  isValueEqualToZero(value:any){
    if (value.changingThisBreaksApplicationSecurity.includes('%')) {
      value.changingThisBreaksApplicationSecurity = value.changingThisBreaksApplicationSecurity.replace(/%/g, '');
    } 
    if(!isNaN(value.changingThisBreaksApplicationSecurity)){
      value=Number(value.changingThisBreaksApplicationSecurity);
    }
    else{
      value=0;
    }
    
    return value==0;
  }


  onTableDataChange(event: any) {
    this.p = event;
    this.start = (this.p - 1) * this.itemsPerPage;
    this.end = this.start + this.itemsPerPage;

    this.getData(this.tableData, this.start, this.end, " ",this.sorting);
  }
  //search($event) function to search the table data based on the input value
  search(event: any) {
    const input = event.target.value.toUpperCase();
    const table = this.customTable?.nativeElement;
    const rows = table?.querySelectorAll('.table-rows');

    if (rows) {
      rows.forEach((row: { querySelectorAll: (arg0: string) => any; style: { display: string; }; }) => {
        const cells = row.querySelectorAll('.data-cells');

        let rowMatch = false;

        cells.forEach((cell: { textContent: any; innerText: any; }) => {
          const textContent = cell.textContent || cell.innerText;
          if (textContent.toUpperCase().indexOf(input) > -1) {
            rowMatch = true;
          }
        });


        row.style.display = rowMatch ? '' : 'none';
      });
    }
    const rows2 = table?.querySelectorAll('.table-rows3');

    const headerCells = table?.querySelectorAll('.header-cells');
    if (headerCells) {
      headerCells.forEach((header: { textContent: any; innerText: any; }, index: number) => {
        const textContent = header.textContent || header.innerText;
        const columnCells = table.querySelectorAll(`.data-cells:nth-child(${index + 1})`);

        if (textContent.toUpperCase().indexOf(input) > -1) {
          columnCells.forEach((cell: { parentElement: { style: { display: string; }; }; }) => {
            if (cell.parentElement) {
              cell.parentElement.style.display = ''; // Show the entire column
            }

          });
        }
      });
    }
  }
  shouldShowRow(row: any) {
    // Get the category name from the row
    if (this.properties.suppressRow) {
      if (!this.properties.transpose) {
        const categoryName = row;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Category Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );

        // Remove the categoryName from this.categories if all values are empty
        if (allValuesEmpty) {
          this.categories = this.categories.filter(category => category !== categoryName);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }

        return allValuesEmpty;
      }
      if (this.properties.transpose) {
        const categoryName = row;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Series Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );

        // Remove the categoryName from this.categories if all values are empty
        if (allValuesEmpty) {
          this.categories = this.categories.filter(category => category !== categoryName);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });

        }

        return allValuesEmpty;
      }
    }
  }
  //getBorderStyle(side: string): string {
  //  let borderStyle = this.properties.borderStyle;
  //  if (this.properties.borderStyle === 'dotted') {
  //    // Increase border thickness by 1 if border style is 'dotted'
  //    borderStyle += ' ' + (parseInt(this.tableService.borderThickness) + 1) + 'px';
  //  } else {
  //    // Otherwise, use the original border thickness
  //    borderStyle += ' ' + this.tableService.borderThickness;
  //  }

  //  // Construct and return the border style for the specified side
  //  return borderStyle + ' ' + this.properties.border;
  //}


  shouldShowCol(col: any) {

    if (this.properties.suppressColumn) {
      if (!this.properties.transpose) {
        const categoryName = col;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Series Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );
        if (allValuesEmpty) {
          this.headers = this.headers.filter((header: any) => header !== categoryName);
          this.headers2 = this.headers.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }
        return allValuesEmpty;
      }
      if (this.properties.transpose) {
        const categoryName = col;

        // Filter categories where the 'Category Name' matches the provided row
        const matchingCategories = this.tableData[0].data.filter((series: { [x: string]: any }) =>
          series['Category Name'] === categoryName
        );

        // Check if all values for the matched categories are empty
        const allValuesEmpty = matchingCategories.every((series: { [x: string]: any }) =>
          series["Rounded Value"] === ""
        );
        if (allValuesEmpty) {
          this.headers = this.headers.filter((header: any) => header !== categoryName);
          this.headers2 = this.headers.map((category: string) => {
            return { colname: category, sortorder: 'nosort' };
          });
        }
        return allValuesEmpty;
      }
    }


  }
  sortAscending(header: any, sortorder: any) {
    this.sorting = sortorder;
    this.sortDirectionAsc = !this.sortDirectionAsc;
    this.header2 = [];
    this.header2.push(header);
    this.header2.push(sortorder);
    // Implement sorting logic for ascending order based on the clicked header
    this.headers2 = this.headers.map((category: string) => {
      return {
        colname: category,
        sortorder: category === header ? sortorder : 'nosort'
      };
    });
    this.getData(this.tableData, this.start, this.end, header,sortorder);
  }

  sortDescending(header: any, sortorder: any) {
    // Implement sorting logic for descending order based on the clicked header
    this.sorting = sortorder;
    this.sortDirectionDesc = !this.sortDirectionDesc;
    this.header2 = [];
    this.header2.push(header);
    this.header2.push(sortorder);
    this.headers2 = this.headers.map((category: string) => {
      return {
        colname: category,
        sortorder: category === header ? sortorder : 'nosort'
      };
    });
    this.getData(this.tableData, this.start, this.end, header,sortorder);
  }


  sortColumn(header: any,sortorder:any) {
    this.clickCounts[header] = this.clickCounts[header] || 0;

    // Increment the click count for the header
    this.clickCounts[header]++;

    // Now you have access to sortOrder (asc or desc) in your TypeScript logic
    if (!this.properties.transpose) {
      this.headers2 = this.headers.map((category: string) => {
        return {
          colname: category,
          sortorder: category === header ? this.getNewSortOrder(this.clickCounts[header]) : 'nosort'
        };
      });
    }
    else {
      this.categories2 = this.categories.map((category: string) => {
        return {
          colname: category,
          sortorder: category === header ? this.getNewSortOrder(this.clickCounts[header]) : 'nosort'
        };
      });
    }
    // Call  getData function 
   // this.getData(this.tableData, this.start, this.end, header);
  }

  getNewSortOrder(clickCount: number): string {
    // Implement your logic here to determine the new sort order based on the click count
    const totalSortOrders = 2; // Assuming you have 2 sort orders: 'asc' and 'desc'
    return clickCount % totalSortOrders === 1 ? 'asc' : 'desc';

  }

  getData(chartData: any, start: any, end: any, colName: any,sortorder:any) {
    // Limit the categories to 10 for the table view
    let seriesData: any[] = [];
    let valuesArray: any[][] = [];
    let deletedCategories: { categoryName: any; seriesWithEmptyValue: any[]; itemData: any[]; }[] = [];
    let sort=sortorder
    if (this.properties.Transpose1) {

      this.headers = this.extractUniqueValues(chartData, 'Category Name');
      this.headers2 = this.headers.map((category: string) => {
        return { colname: category, sortorder: category === colName ? sort : 'nosort' };
      });

      this.categories = this.extractUniqueValues(chartData, 'Series Name');
      this.categories2 = this.categories.map((category: string) => {
        return {
          colname: category, sortorder: category === colName ? sort : 'nosort' };
      });



    } else {

      this.headers = this.extractUniqueValues(chartData, 'Series Name');
      this.headers2 = this.headers.map((category: string) => {
        return { colname: category, sortorder: category === colName ? sort : 'nosort' };
      });
      this.categories = this.extractUniqueValues(chartData, 'Category Name');
      this.categories2 = this.categories.map((category: string) => {
        return { colname: category, sortorder: category === colName ? sort : 'nosort' };
      });
    }

    if(this.isOutput){
      if(this.properties.hideNA){
            let columnName='Series Name';
            let RowName='Category Name';
            if (this.properties.Transpose1){
              columnName='Category Name';
              RowName='Series Name';
            }
            let headercount = this.headers.length;
            let CategerioesCount = this.categories.length;
            this.headers= this.headers.filter((x:any)=>{
                    let count=0;
                    chartData.forEach((y:any)=>{
                          if(x==y[columnName]){
                              if(y['Label']==null || y['Label']=="NA" || y['Label']==undefined){
                                  count=count+1;
                              }
                          }
                    });
                    if(count!=CategerioesCount)
                      return x;
                });

                this.categories= this.categories.filter((x:any)=>{
                  let count=0;
                  chartData.forEach((y:any)=>{
                      if(x==y[RowName]){
                          if(y['Label']==null || y['Label']=="NA" || y['Label']==undefined){
                              count=count+1;
                          }
                      }
                  });
                  if(count!=headercount)
                  return x;
            });
      }

      if(this.properties.selectedColumn != undefined){
         if(this.properties.selectedsorting == "asc"){
             this.sortTableDataAscending(this.properties.selectedColumn)
         }
         else{
              this.sortTableDataDescending(this.properties.selectedColumn)
         }
      }
      
      if (this.properties.sort == "ascending") {
        this.headers.sort((a:any, b:any) => a.localeCompare(b));  // Sorts alphabetically
      } else if (this.properties.sort == "descending") {
        this.headers.sort((a:any, b:any) => b.localeCompare(a));  // Sorts in reverse alphabetical order
      }
    }

    this.headers1 = this.categories.slice(start, end);


    // if (!this.properties.Transpose) {
    //   const columnIndex = this.headers.indexOf(colName);
    //   if (columnIndex !== -1) {

    //     if (this.headers2[columnIndex].sortorder === 'asc') {
    //       this.sortTableDataAscending(colName);
    //     } else if (this.headers2[columnIndex].sortorder === 'desc') {
    //       this.sortTableDataDescending(colName);
    //     }
    //   }
    // }


  }

HideNA(uniqueCategoryNames:any){
  let columnName='Series Name';
  let RowName='Category Name';
  if (this.properties.Transpose1){
    columnName='Category Name';
    RowName='Series Name';
  }
  this.headers= this.headers.filter((x:any)=>{
          let count=0;
          this.chartMainData.forEach((y:any)=>{
                if(x==y[columnName]){
                    if(y['Label']==null || y['Label']=="NA" || y['Label']==undefined){
                        count=count+1;
                    }
                }
          });
          if(count!=this.headers.length)
            return x;
      });

      let categories= this.categories.filter((x:any)=>{
        let count=0;
        this.chartMainData.forEach((y:any)=>{
            if(x==y[RowName]){
                if(y['Label']==null || y['Label']=="NA" || y['Label']==undefined){
                    count=count+1;
                }
            }
        });
        if(count!=this.categories.length)
        return x;
  });

  const common = uniqueCategoryNames.filter((value:any) => categories.includes(value));

  return common;
}

SortHideNA(uniqueCategoryNames:any,HideNAcategories:any){
  const common = uniqueCategoryNames.filter((value:any) => HideNAcategories.includes(value));
  return common;
}


 sortTableDataAscending(seriesName: string): void {
    let column='Series Name';
    let row='Category Name';
    if (this.properties.Transpose1) {
      column='Category Name';
      row='Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
      if(filteredData.length > 0){
        //const sortedValuesArray = _.orderBy(filteredData, 'Rounded Value', 'asc');
        const sortedValuesArray =  _.orderBy(filteredData, 
          [(item) => item['Rounded Value'] === 'NA' ? -Infinity : item['Rounded Value']], 
          ['asc']);
        // Update the original array with the sorted values for the specified seriesName
        let sortedIndex = 0;
        let sortedData = [];
        sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
          if (item[column] === seriesName) {
            const sortedItem = sortedValuesArray[sortedIndex];
            sortedIndex++;
            return sortedItem || item;
          }
          return item;
        });
        const extractedCategoryNames: string[] = sortedData
          .filter((item: { [x: string]: string }) => item[column] === seriesName)
          .map((item: { [x: string]: string }) => item[row]);



        const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));
        let categories:any
        // if(this.properties.hideNA)
        //   categories = this.HideNA(uniqueCategoryNames);
        // else
        //   categories = uniqueCategoryNames;
        this.categories = this.SortHideNA(uniqueCategoryNames,this.categories);

        this.categories2 = this.categories.map((category: string) => {
          return { colname: category };
        });


        this.chartMainData= [];
        this.chartMainData = sortedData;
        this.selectedColumn = seriesName;
        this.selectedascending ="asc";
        this.properties.selectedColumn = seriesName;
        this.properties.selectedsorting ="asc";
        for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
          if(this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
            this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(this.properties);
          }
        }
     }
    //  else{
    //   if(this.properties.hideNA){
    //     this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }

  Transpose(){
    if (this.properties.Transpose1) {
      this.headers = this.extractUniqueValues(this.chartMainData, 'Category Name');
      this.categories = this.extractUniqueValues(this.chartMainData, 'Series Name');
    } else {
      this.headers = this.extractUniqueValues(this.chartMainData, 'Series Name');
      this.categories = this.extractUniqueValues(this.chartMainData, 'Category Name');
    }
  }

   sortTableDataDescending(seriesName: string): void {
    let column='Series Name';
    let row='Category Name';
    if (this.properties.Transpose1) {
      column='Category Name';
      row='Series Name';
    }
    const filteredData = this.chartMainData.filter((item: { [x: string]: string; }) => item[column] === seriesName);
      if(filteredData.length > 0){
         // const sortedValuesArray = _.orderBy(filteredData, 'Rounded Value', 'desc');
         const sortedValuesArray =  _.orderBy(filteredData, 
          [(item) => item['Rounded Value'] === 'NA' ? Number.NEGATIVE_INFINITY : item['Rounded Value']], 
          ['desc']);

          // Update the original array with the sorted values for the specified seriesName
          let sortedIndex = 0;
          let sortedData = [];
          sortedData = this.chartMainData.map((item: { [x: string]: string; }) => {
            if (item[column] === seriesName) {
              const sortedItem = sortedValuesArray[sortedIndex];
              sortedIndex++;
              return sortedItem || item;
            }
            return item;
          });
          const extractedCategoryNames: string[] = sortedData
            .filter((item: { [x: string]: string }) => item[column] === seriesName)
            .map((item: { [x: string]: string }) => item[row]);



          const uniqueCategoryNames: string[] = Array.from(new Set(extractedCategoryNames));
          let categories:any
          // if(this.properties.hideNA)
          //   categories = this.HideNA(uniqueCategoryNames);
          // else
          //   categories = uniqueCategoryNames;
          this.categories =  this.SortHideNA(uniqueCategoryNames,this.categories);
          this.categories2 = this.categories.map((category: string) => {
            return { colname: category };
          });
          this.chartMainData = [];
          this.chartMainData = sortedData;
          this.selectedColumn = seriesName;
          this.selectedascending ="desc";
          this.properties.selectedColumn = seriesName;
          this.properties.selectedsorting ="desc";
          for(let i=0;i<this._configService.allPageOutputDataWithoutTrend[0].length;i++){
            if(this.CurrentWidgetName == this._configService.allPageOutputDataWithoutTrend[0][i].widget_name){
              this._configService.allPageOutputDataWithoutTrend[0][i].customizationProperties=JSON.stringify(this.properties);
            }
          }
     }
    //  else{
    //   if(this.properties.hideNA){
    //       this.HideNA2();
    //   }
    //   else{
    //     this.Transpose();
    //   }
    //  }
  }

 HideNA2(){
  let columnName='Series Name';
  let RowName='Category Name';
  if (this.properties.Transpose1){
    columnName='Category Name';
    RowName='Series Name';
  }
  let headercount = this.headers.length;
            let CategerioesCount = this.categories.length;
  this.headers= this.headers.filter((x:any)=>{
          let count=0;
          this.chartMainData.forEach((y:any)=>{
                if(x==y[columnName]){
                    if(y['Label']==null || y['Label']=="NA" || y['Label']==undefined){
                        count=count+1;
                    }
                }
          });
          if(count!=headercount)
            return x;
      });

      this.categories= this.categories.filter((x:any)=>{
        let count=0;
        this.chartMainData.forEach((y:any)=>{
            if(x==y[RowName]){
                if(y['Label']==null || y['Label']=="NA" || y['Label']==undefined){
                    count=count+1;
                }
            }
        });
        if(count!=CategerioesCount)
        return x;
  });
 }


  getDataCell(row: any, col: any) { 

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if(this.isOutput){
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else{
        if (this.properties.Transpose1) {
          matchingItems = this.tableData[0].data.filter((item: any) =>
            item['Category Name'] === col && item['Series Name'] === row
          );
        } else {
          matchingItems = this.tableData[0].data.filter((item: any) =>
            item['Category Name'] === row && item['Series Name'] === col
          );
        }
    }

    // Process and store the cell data
    matchingItems.forEach((item: any) => {
      let value = "";
      if (this.properties.datalabelProperty == "default" || this.properties.datalabelProperty == "datalabel") {
        value = (item['Label'] == "" || item['Label'] == "NA") && item['Label'] != "0" ? 'NA' :parseFloat(Number(item['Label']).toFixed(this.properties.decimalRoundOff)) + (item['isPercentage'] ? "%" : '');
      } else if (this.properties.datalabelProperty == "change") {
        value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:black">' + '(' + item["Change value vs PY"] + ')' +'</span>';
      } else if (this.properties.datalabelProperty == "significance + changeVs") {
        let sig = item['Significance'];
        let sColor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
        let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');

        value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:black">' + '(' + item["Change value vs PY"] + ')' +'</span>'+ '<span style="color: ' + sColor + '">' + s + '</span>';

      } else if (this.properties.datalabelProperty == "ls") {
        let sampleSize = item["Sample size"];
        value = item['Rounded Value'] == "" ? 'NA' : sampleSize < 9000 ? 'LS' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '');
      }
      else if (this.properties.datalabelProperty == "significance") {
        let sig = item['Significance'];
        let sColor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
        let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
        value = item['Rounded Value'] == 0 ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color: ' + sColor + '">' + s + '</span>';
      }
      else if (this.properties.datalabelProperty == "significance2") {

        let sig2 = item['Significance2'];
        let sig = item['Significance'];
        let sColor = sig > 0 ? this.tableService.highSignificance : this.tableService.lowSignificance;
        let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
        let changeTextColor = sig2 > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : 'black');

        value = item['Rounded Value'] == "" ? 'NA' : item['Rounded Value'] + (this.properties.datalabelFormat == "percentage" ? "%" : '') + '<span style="color:' + changeTextColor + '">(' + item["Change value vs PY"] + ')</span>' + '<span style="color: ' + sColor + '">' + s + '</span>';

      }
      dataArray.push(value);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return this.sanitizer.bypassSecurityTrustHtml(dataArray.join(''));
  }

  getChangeVsCell(row: any, col: any) { 

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if(this.isOutput){
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else{
        if (this.properties.Transpose1) {
          matchingItems = this.tableData[0].data.filter((item: any) =>
            item['Category Name'] === col && item['Series Name'] === row
          );
        } else {
          matchingItems = this.tableData[0].data.filter((item: any) =>
            item['Category Name'] === row && item['Series Name'] === col
          );
        }
    }

    // Process and store the cell data
    matchingItems.forEach((item: any) => {
      let value = "";
      if(this._configService.isIndexSelected==false){
          if (this.SigValue != "None") {
            value = (item['Change value vs PY'] ==null || item['Change value vs PY'] == "" || item['Change value vs PY'] == "NA")  && item['Change value vs PY'] != 0 ? '(NA)' :"("+parseFloat(Number(item['Change value vs PY'] * 100).toFixed(1)) + "%)";
          }
      }
      else if(this._configService.isIndexSelected==true){
        value = (item['ValueForIndex'] ==null || item['ValueForIndex'] == "" || item['ValueForIndex'] == "NA")  && item['ValueForIndex'] != 0 ? '(NA)' :"("+parseFloat(Number(item['ValueForIndex']).toFixed(1)) + ")";
      }
      dataArray.push(value);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return this.sanitizer.bypassSecurityTrustHtml(dataArray.join(''));
  }

  getSigCell(row: any, col: any) { 

    const cacheKey = `${row}_${col}`;

    // Check if the processed data for the cell is already cached
    //if (this.dataCellCache[cacheKey]) {
    //  return this.dataCellCache[cacheKey];
    //}

    let dataArray: any[] = [];
    let matchingItems;
    if(this.isOutput){
      if (this.properties.Transpose1) {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === col && item['Series Name'] === row
        );
      } else {
        matchingItems = this.chartMainData.filter((item: any) =>
          item['Category Name'] === row && item['Series Name'] === col
        );
      }
    }
    else{
        if (this.properties.Transpose1) {
          matchingItems = this.tableData[0].data.filter((item: any) =>
            item['Category Name'] === col && item['Series Name'] === row
          );
        } else {
          matchingItems = this.tableData[0].data.filter((item: any) =>
            item['Category Name'] === row && item['Series Name'] === col
          );
        }
    }
    let color:any;
    // Process and store the cell data
    matchingItems.forEach((item: any) => {
      let value = "";
      if(this._configService.isIndexSelected==false){
          if (this.SigValue != "None") {
            color = item['Significance_Value'] < this.Sig_LowerLimt ? 'red' : (item['Significance_Value'] > this.Sig_UpperLimt ? 'green' : 'black');
          }
      }
      else{
         color = this._configService.CheckIndexColoring(String(item['ActualIndexValue']));
      }
      dataArray.push(color);
    });

    // Cache the processed cell data
    this.dataCellCache[cacheKey] = dataArray;

    //return dataArray;
    return (dataArray.join(''));
  }

  private extractUniqueValues(chartData: any, propertyName: string): string[] {
    return [...new Set(
      chartData
        .map((item:any) => item[propertyName])
        .flat()
        .filter((value: undefined) => value !== undefined)
    )] as string[];
  }



  customization() {
    //return this.tableService.customizationService();
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("Table", this._customSnapshotService.selectedSnapshotType?.name));
  }
  commonfunc(event: any, customization: string, options: any) {
    let property;

    this.tableService.commonFunc(customization, event, this.properties, this.customTable, this.headerElement);
    this.itemsPerPage = this.properties.pagination ? this.categories.length : 10;
    this.getData(this.tableData, this.start, this.end, " ",this.sorting);

  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.tableService.applycustomization(event, item, this.properties)
    localStorage.setItem("properties", JSON.stringify(this.properties));
    //this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
    //this.properties.ColumnHeaderFontSize="0.5em";
  }

  hexToRgb(hex: string): string {
    // Remove the '#' if it's included
    hex = hex.replace('#', '');

    // Convert the hex to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `${r}, ${g}, ${b}`; // Returns rgb(r, g, b)
  }

  GetRowName(name:any){
    if(!this.isOutput){
    if(this._customSnapshotService.selectedSnapshotType.name == "Multiple Markets")
      return name.replace(/Brand/g, "Market")
    else
     return name;
    }
    else{
      return name;
    }
  }

  userselectedproperties() {

    this.data["properties"][0] = this.properties;

    return JSON.stringify(this.data).toString();
  }

  getMarginForScroll() {
    let tblRef: any = document.getElementById('table-scroll');
    if (tblRef != null) {
      let theadRef = tblRef.getElementsByTagName('thead');
      let fixedcolRef = tblRef.getElementsByClassName('FreezedColumn');
      let xscroll=fixedcolRef[0].clientWidth;
      if(this.properties?.Transpose1 != undefined){
         fixedcolRef=tblRef.getElementsByTagName('tbody')[0].firstChild.clientWidth
         xscroll=Number(fixedcolRef)%this.categories.length+1;
      }
      if (theadRef != null && theadRef.length > 0) {
        //return `${theadRef[0].clientHeight}px 0 0 ${fixedcolRef[0].clientWidth}px`;
        return `${theadRef[0].clientHeight}px 0 0 150px`;
      }
    }
    return 0;
  }

  index = -1;
}


